import React from "react";
import {
  pdf,
  Page,
  Text,
  View,
  Document,
  Font,
  StyleSheet,
} from "@react-pdf/renderer";
import Header from "./Images/Header.png";
import Footer from "./Images/Footer.png";
import { Image as PdfImage } from "@react-pdf/renderer";
import CustomerApi from "../../API/CustomerApi";
import Swal from "sweetalert2";

Font.register({
  family: "Helvetica-Bold",
  src: "https://cdnjs.cloudflare.com/ajax/libs/pdfkit/0.10.0/font/Helvetica-Bold.afm",
});

const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    backgroundColor: "#FFFFFF",
    padding: 20,
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
  title: {
    fontSize: 24,
    textAlign: "center",
    marginBottom: 20,
  },
  text: {
    fontSize: 11,
  },
  bold: {
    fontFamily: "Helvetica-Bold",
    fontSize: 11,
  },
});

function getDate() {
  const today = new Date();
  const month = today.getMonth() + 1;
  const year = today.getFullYear();
  const date = today.getDate();
  return `${date}/${month}/${year}`;
}

const PdfDocument = ({ formData }) => (
  <Document>
    <Page size="A4" style={styles.page}>
      <View style={styles.section}>
        <PdfImage src={Header} style={{ width: "100%", height: 80 }} />
        <Text
          style={[
            styles.text,
            {
              textAlign: "left",
              width: "100%",
              marginTop: 20,
              fontSize: 11,
              lineHeight: 1.5,
              marginBottom: 10,
            },
          ]}
        >
          Thank you for choosing Point Broadband as your service provide. As you
          are aware, you may continue to use your existing telephone number with
          us. In order to transition your current telephone number to our
          service, Point Broadband must work with your previous service provider
          to ensure that your service is uninterrupted, and where applicable, to
          ensure that your number is transferred.
        </Text>

        <Text
          style={[
            styles.text,
            {
              textAlign: "left",
              width: "100%",
              marginTop: 5,
              fontSize: 11,
              lineHeight: 1.5,
            },
          ]}
        >
          Your prior service provider requires this letter as proof that you
          have explicitly authorized and requested that your service and current
          telephone number be transferred to another provider. By filling in all
          the information requested below and signing and dating this letter,
          you provide us with the authorization to initiate the process of
          transferring your service and telephone number to Point Broadband.
        </Text>
        <Text
          style={[
            styles.bold,
            {
              textAlign: "left",
              width: "100%",
              marginTop: 10,
              fontSize: 11,
              lineHeight: 1.5,
            },
          ]}
        >
          When completed & signed, please return to:
        </Text>

        <Text
          style={[
            {
              textAlign: "left",
              width: "100%",
              fontSize: 11,
              lineHeight: 1.5,
            },
          ]}
        >
          PO Box 429
        </Text>

        <Text
          style={[
            {
              textAlign: "left",
              width: "100%",
              fontSize: 11,
              lineHeight: 1.5,
            },
          ]}
        >
          Bristol, VA 24203
        </Text>

        <Text
          style={[
            {
              textAlign: "left",
              width: "100%",
              fontSize: 11,
              lineHeight: 1.5,
            },
          ]}
        >
          Or customerservice@point-broadband.com
        </Text>

        <Text
          style={[
            styles.bold,
            {
              textAlign: "left",
              width: "100%",
              marginTop: 10,
              fontSize: 11,
              lineHeight: 1.5,
            },
          ]}
        >
          Please ensure the below information is completed in entirety to avoid
          possible delays.
        </Text>

        <View style={{ flexDirection: "row", alignItems: "center" }}>
          <Text
            style={{
              textAlign: "left",
              marginTop: 12,
              fontSize: 11,
              lineHeight: 1.5,
              fontFamily: "Helvetica-Bold",
            }}
          >
            Current Name on Bill:
          </Text>
          <Text
            style={{
              fontSize: 11,
              marginTop: 12,
              textAlign: "left",
              lineHeight: 1.5,
              marginLeft: 5,
              fontWeight: "normal",
              textDecoration: "underline",
            }}
          >
            {formData.name}
          </Text>
        </View>

        <View style={{ flexDirection: "row", alignItems: "center" }}>
          <Text
            style={{
              textAlign: "left",
              marginTop: 12,
              fontSize: 11,
              lineHeight: 1.5,
              fontFamily: "Helvetica-Bold",
            }}
          >
            Physical Address:
          </Text>
          <Text
            style={{
              fontSize: 11,
              marginTop: 12,
              textAlign: "left",
              lineHeight: 1.5,
              marginLeft: 5,
              fontWeight: "normal",
              textDecoration: "underline",
            }}
          >
            {formData.address}
          </Text>
        </View>

        <View
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <View style={{ flexDirection: "row", alignItems: "center" }}>
            <Text
              style={{
                textAlign: "left",
                marginTop: 12,
                fontSize: 11,
                lineHeight: 1.5,
                fontFamily: "Helvetica-Bold",
              }}
            >
              City:
            </Text>
            <Text
              style={{
                fontSize: 11,
                marginTop: 12,
                textAlign: "left",
                lineHeight: 1.5,
                marginLeft: 5,
                fontWeight: "normal",
                textDecoration: "underline",
              }}
            >
              {formData.city}
            </Text>
          </View>

          <View style={{ flexDirection: "row", alignItems: "center" }}>
            <Text
              style={{
                textAlign: "left",
                marginTop: 12,
                fontSize: 11,
                lineHeight: 1.5,
                fontFamily: "Helvetica-Bold",
              }}
            >
              State:
            </Text>
            <Text
              style={{
                fontSize: 11,
                marginTop: 12,
                textAlign: "left",
                lineHeight: 1.5,
                marginLeft: 5,
                fontWeight: "normal",
                textDecoration: "underline",
              }}
            >
              {formData.state}
            </Text>
          </View>

          <View style={{ flexDirection: "row", alignItems: "center" }}>
            <Text
              style={{
                textAlign: "left",
                marginTop: 12,
                fontSize: 11,
                lineHeight: 1.5,
                fontFamily: "Helvetica-Bold",
              }}
            >
              Zip Code:
            </Text>
            <Text
              style={{
                fontSize: 11,
                marginTop: 12,
                textAlign: "left",
                lineHeight: 1.5,
                marginLeft: 5,
                fontWeight: "normal",
                textDecoration: "underline",
              }}
            >
              {formData.zip_code}
            </Text>
          </View>
        </View>

        <View style={{ flexDirection: "row", alignItems: "center" }}>
          <Text
            style={{
              textAlign: "left",
              marginTop: 12,
              fontSize: 11,
              lineHeight: 1.5,
              fontFamily: "Helvetica-Bold",
            }}
          >
            Current Service Provider:
          </Text>
          <Text
            style={{
              fontSize: 11,
              marginTop: 12,
              textAlign: "left",
              lineHeight: 1.5,
              marginLeft: 5,
              fontWeight: "normal",
              textDecoration: "underline",
            }}
          >
            {formData.cuuentServiceProvider}
          </Text>
        </View>

        <View style={{ flexDirection: "row", alignItems: "center" }}>
          <Text
            style={{
              textAlign: "left",
              marginTop: 12,
              fontSize: 11,
              lineHeight: 1.5,
              fontFamily: "Helvetica-Bold",
            }}
          >
            Account Number:
          </Text>
          <Text
            style={{
              fontSize: 11,
              marginTop: 12,
              textAlign: "left",
              lineHeight: 1.5,
              marginLeft: 5,
              fontWeight: "normal",
              textDecoration: "underline",
            }}
          >
            {formData.account_number}
          </Text>
        </View>

        <View style={{ flexDirection: "row", alignItems: "center" }}>
          <Text
            style={{
              textAlign: "left",
              marginTop: 12,
              fontSize: 11,
              lineHeight: 1.5,
              fontFamily: "Helvetica-Bold",
            }}
          >
            PIN/Password:
          </Text>
          <Text
            style={{
              fontSize: 11,
              marginTop: 12,
              textAlign: "left",
              lineHeight: 1.5,
              marginLeft: 5,
              fontWeight: "normal",
              textDecoration: "underline",
            }}
          >
            {formData.password_pin}
          </Text>
        </View>

        <View style={{ flexDirection: "row", alignItems: "center" }}>
          <Text
            style={{
              textAlign: "left",
              marginTop: 12,
              fontSize: 11,
              lineHeight: 1.5,
              fontFamily: "Helvetica-Bold",
            }}
          >
            Phone Number (to be transferred):
          </Text>
          <Text
            style={{
              fontSize: 11,
              marginTop: 12,
              textAlign: "left",
              lineHeight: 1.5,
              marginLeft: 5,
              fontWeight: "normal",
              textDecoration: "underline",
            }}
          >
            {formData.phone}
          </Text>
        </View>

        <PdfImage
          src={formData.signature}
          style={{ width: 100, height: 50, marginLeft: 130 }}
        />

        <View
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <View style={{ flexDirection: "row", alignItems: "center" }}>
            <Text
              style={{
                textAlign: "left",
                fontSize: 11,
                lineHeight: 1.5,
                fontFamily: "Helvetica-Bold",
              }}
            >
              Customer Signature:
            </Text>
            <Text
              style={{
                fontSize: 11,
                textAlign: "left",
                lineHeight: 1.5,
                marginLeft: 5,
                fontWeight: "normal",
              }}
            >
              _______________________________
            </Text>
          </View>

          <View style={{ flexDirection: "row", alignItems: "center" }}>
            <Text
              style={{
                textAlign: "left",
                fontSize: 11,
                lineHeight: 1.5,
                fontFamily: "Helvetica-Bold",
              }}
            >
              Date:
            </Text>
            <Text
              style={{
                fontSize: 11,
                textAlign: "left",
                lineHeight: 1.5,
                marginLeft: 5,
                fontWeight: "normal",
                textDecoration: "underline",
              }}
            >
              {getDate()}
            </Text>
          </View>
        </View>

        <Text
          style={[
            styles.text,
            {
              textAlign: "left",
              width: "100%",
              fontSize: 9,
              lineHeight: 1.5,
            },
          ]}
        >
          (must be authorized on current account)
        </Text>

        <Text
          style={[
            styles.text,
            {
              textAlign: "left",
              width: "100%",
              marginTop: 30,
              fontSize: 8,
              lineHeight: 1,
              marginBottom: 10,
            },
          ]}
        >
          This institution is an equal opportunity provider and employer.
        </Text>

        <Text
          style={[
            styles.text,
            {
              textAlign: "left",
              width: "100%",
              marginTop: 5,
              fontSize: 8,
              lineHeight: 1,
            },
          ]}
        >
          By signing this letter, you authorize Point Broadband to initiate the
          process of transferring your service and telephone number to Point
          Broadband.If you wish to file a Civil Rights program complaint of
          discrimination, complete the USDA Program Discrimination Complaint
          Form, found online at
          http://www.ascr.usda.gov/complaint_filing_cust.html, or at any USDA
          office, or call (866) 632-9992 to request the form. You may also write
          a letter containing all of the information requested in the form. Send
          your completed complaint for or letter to us by mail at U.S.
          Department of Agriculture, Director, Office of Adjudication, 1400
          Independence Avenue, S.W. Washington, D.C. 20250-9410, by fax (202)
          690-7442 or email at program.intake.usda.gov.
        </Text>
        <PdfImage
          src={Footer}
          style={{ width: "100%", height: 20, marginTop: 20 }}
        />
      </View>
    </Page>
  </Document>
);

export const generateAndSendPdf = async (formData,onClose) => {
  try {
    const pdfBlob = await pdf(<PdfDocument formData={formData} />).toBlob();

    Swal.fire({
      icon:"info",
      title: "Generating PDF",
      text: "Please wait while we generate the Letter of Authorization PDF...",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
  })

    const res = await CustomerApi.SendEmailOfLetterOfAuthorization(pdfBlob);

    if(res.success) {
      Swal.fire({
        title: "Success",
        text: "Letter of Authorization PDF has been sent successfully!",
        icon: "success",
        confirmButtonText: "OK",
      });
      onClose(); // Close the modal after successful email sending
    }
    else{
      Swal.fire({
        title: "Error",
        text: "Failed to send the Letter of Authorization PDF. Please try again.",
        icon: "error",
        confirmButtonText: "OK",
      });
      onClose(); // Close the modal even if sending fails
    }

  } catch (error) {
    console.error("Error generating and sending PDF:", error);
  }
};

const PdfFile = ({ formData }) => {
  return null;
};

export default PdfFile;